import React, { useState, useEffect } from 'react';

// Diwali dates by year (Month is 0-indexed: 9 = Oct, 10 = Nov)
const diwaliDates = {
  2024: new Date(2024, 9, 31),
  2025: new Date(2025, 9, 20),
  2026: new Date(2026, 10, 8),
  2027: new Date(2027, 9, 29),
};

const getTargetDiwaliDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  let target = diwaliDates[year] || new Date(year, 9, 25);
  if (today > target) {
    target = diwaliDates[year + 1] || new Date(year + 1, 9, 25);
  }
  return target;
};

const calculateDaysUntilDiwali = () => {
  const today = new Date();
  const diwali = getTargetDiwaliDate();
  const diffTime = diwali - today;
  const diffDays = Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
  return diffDays;
};

const Countdown = () => {
  const [daysLeft, setDaysLeft] = useState(calculateDaysUntilDiwali());

  useEffect(() => {
    const timer = setInterval(() => {
      setDaysLeft(calculateDaysUntilDiwali());
    }, 1000 * 60 * 60);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className='countdown-box'>
      <div className='d-flex align-items-center justify-content-center gap-2'>
        <span>🪔</span>
        <span>
          <strong>{daysLeft}</strong> Days to Grand Diwali Celebration!
        </span>
        <span>✨</span>
      </div>
    </div>
  );
};

export default Countdown;
